module.exports = __webpack_public_path__ + "static/media/doc-02-build.913346d3.svg";